import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import _ from 'lodash';

export function PostCopyRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.PostCopy', {
		url: '/post/:id/copy',
		controllerAs: 'vm',
		controller: PostCopyCtrl,
		templateUrl: '/ng/hub/PostCopy/PostCopyCtrl.html?' + window.BUILD,
		resolve: {
			$style: () => AssetManager.css('/ng/hub/PostCopy/PostCopyCtrl.css'),
			$title: () => 'Copy a Post',
		},
	});
}

export class PostCopyCtrl {
	// QUESTION: should we check Identity.can('copy')?
	constructor(Api, Identity, $stateParams) {
		'ngInject';
		this.Api = Api;
		this.Identity = Identity;
		this.postId = $stateParams.id;

		// use all hubs except the current
		this.hubs = _.filter(Identity.allowedClients(), { current: false });
		this.destinationHubs = [];
		this.finished = false;
		this.successfulCopyHubs = [];
		this.unsuccessfulCopyHubs = [];
	}

	/**
	 * Runs after click of the Copy button. Sends POST request to API with
	 * selected hubs.
	 */
	copy() {
		this.Api.post(`/posts/${this.postId}/copy`, { hubs: this.destinationHubs }).then(data => {
			let good = _.filter(data, res => res.success);
			this.successfulCopyHubs = _.map(good, res => _.filter(this.hubs, { id: res.hub_id })[0]);
			let bad = _.filter(data, res => !res.success);
			this.unsuccessfulCopyHubs = _.map(bad, res => _.filter(this.hubs, { id: res.hub_id })[0]);
			this.finished = true;
		});
	}

	hasSuccessesAndErrors() {
		return this.successfulCopyHubs.length > 0 && this.unsuccessfulCopyHubs.length > 0;
	}
}
